import {
  AxisSwitcher,
  BorderGridContainer,
  Clickable,
  GridBox,
  H2,
  H3,
  P,
  SpacerWrapper,
  TypeWrapper,
} from '@ahmdigital/ui';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { map } from 'lodash/fp';
// @ts-expect-error - Automatic, Please fix when editing this file
import liveChatActions from '@ahmdigital/livechat/lib/actions';

import getSupportData from '../../data/support';
import styles from './styles.module.sass';

type SupportProps = {
  actions: {
    launch: (...args: unknown[]) => unknown;
  };
};

const Support = ({ actions }: SupportProps) => {
  const supportData = getSupportData(actions);
  return (
    <BorderGridContainer>
      <GridBox padding="1rem">
        <div className={styles.wrapper}>
          <SpacerWrapper variant={['marginBottomSpacer3', 'marginTopSpacer3']}>
            <TypeWrapper variant="center">
              <H2 looksLike="h3" variant="marginBottomSpacer7">
                Support when you need it.
              </H2>
              <AxisSwitcher limit={3} threshold="60rem" space="2rem">
                {map(({ className, link, onClick, title, subtitle }) => {
                  const clickableAction = link ? { to: link } : { onClick };
                  return (
                    <Clickable key={title} isUnstyled {...clickableAction} className={className}>
                      <H3 looksLike="h4" variant={['withoutMargin', 'regular', styles.supportHeading]}>
                        {title}
                      </H3>
                      {subtitle && <P variant={styles.supportContent}>{subtitle}</P>}
                    </Clickable>
                  );
                }, supportData)}
              </AxisSwitcher>
            </TypeWrapper>
          </SpacerWrapper>
        </div>
      </GridBox>
    </BorderGridContainer>
  );
};

// @ts-expect-error - Automatic, Please fix when editing this file
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(liveChatActions, dispatch),
});

export default connect(null, mapDispatchToProps)(Support);

export { Support as SupportForTest, mapDispatchToProps };
